const guiColors = {
    'motion-primary': 'oklab(0.55 0.12 -0.07)',
    'motion-primary-transparent': 'oklab(0.55 0.12 -0.07 / 0.75)',
    'motion-tertiary': 'oklab(0.47 0.14 -0.08)',

    'looks-secondary': 'oklab(0.55 0.12 -0.07)',
    'looks-transparent': 'oklab(0.55 0.12 -0.07 / 0.35)',
    'looks-light-transparent': 'oklab(0.55 0.12 -0.07 / 0.15)',
    'looks-secondary-dark': 'oklab(0.45 0.13 -0.08)',

    'extensions-primary': 'oklab(0.57 0.23 0.00)',
    'extensions-tertiary': 'oklab(0.40 -0.03 -0.18)',
    'extensions-transparent': 'oklab(0.57 0.23 0.00 / 0.35)',
    'extensions-light': 'oklab(0.75 0.06 -0.04)',

    'drop-highlight': 'oklab(0.57 0.23 0.00)',

    'menu-bar-background-image':
        'linear-gradient(90deg, ' +
        'oklab(0.57 0.23 0.00 / 0.75) 0%, ' +
        'oklab(0.55 0.12 -0.07 / 0.75) 50%, ' +
        'oklab(0.40 -0.03 -0.18 / 0.75) 100%)'
};

const blockColors = {
    checkboxActiveBackground: 'oklab(0.55 0.12 -0.07)',
    checkboxActiveBorder: 'oklab(0.57 0.23 0.00)'
};

export {
    guiColors,
    blockColors
};
